import { IViolationFixMethod } from 'APIPackage/CatalogsModule/interfaces/IViolationFixMethod';
import { IViolationFixMethodSelectOption } from 'CorePackage/CatalogsModule/interfaces/IViolationFixMethodSelectOption';

export function createViolationFixMethodSelectOption(
  violationFixMethod: IViolationFixMethod,
): IViolationFixMethodSelectOption {
  return {
    ...violationFixMethod,
    label: violationFixMethod.title,
    value: violationFixMethod.code,
  };
}
